<footer>
  <div class="width-100 blue-container">
    <span>Powered By&nbsp;YAAGO&nbsp;</span>
    <!--<a href="https://yaago.com" target="_blank" class="margin-left-8 txt-color-white" >Yaago</a>-->
  </div>
</footer>
